import React, { useState } from 'react';
import CPFValidation from './components/CPFValidation';
import FileUpload from '../FileUpload/FileUpload';

export default function UploadCertificateUploader() {
  const [validationStep, setValidationStep] = useState<
    'cpfValidation' | 'upload'
  >('cpfValidation');
  const [cpf, setCpf] = useState('');

  const onCpfValid = (validCpf: string) => {
    setCpf(validCpf);
    setValidationStep('upload');
  };

  return (
    <>
      {validationStep === 'cpfValidation' && (
        <CPFValidation onValidCpf={onCpfValid} />
      )}
      {validationStep === 'upload' && <FileUpload validCpf={cpf} />}
    </>
  );
}
